import React from 'react'
import styles from './styles.module.scss'
import clsx from 'clsx'

type PlusMinusProps = {
    open: boolean
    style?: React.CSSProperties
    onClick?: () => void
}

export const PlusMinus = ({ open, style, onClick }: PlusMinusProps) => {
    return (
        <div className={clsx(styles.icon, open && styles.open)} style={style} onClick={onClick}>
            <div className={styles.vertical} />
            <div className={styles.horizontal} />
        </div>
    )
}
